import * as React from 'react';
export const clerkSvg = React.forwardRef(function clerkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#6C47FF',
      d: 'M0 .002h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.993 19.552a3.557 3.557 0 1 0 0-7.115 3.557 3.557 0 0 0 0 7.115Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.32 6.53c.355.239.386.74.083 1.042l-2.6 2.6a.768.768 0 0 1-.895.12 6.403 6.403 0 0 0-8.618 8.618.768.768 0 0 1-.12.895l-2.6 2.6c-.302.302-.803.272-1.041-.084a11.33 11.33 0 0 1-1.92-6.326c0-6.287 5.097-11.383 11.384-11.383 2.341 0 4.517.707 6.327 1.918Z',
      fill: '#fff',
      fillOpacity: 0.4,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.403 24.417c.302.303.272.804-.084 1.042a11.33 11.33 0 0 1-6.326 1.919 11.33 11.33 0 0 1-6.327-1.92c-.356-.237-.386-.738-.084-1.041l2.6-2.6a.769.769 0 0 1 .895-.12 6.38 6.38 0 0 0 2.916.7c1.05 0 2.04-.252 2.915-.7a.77.77 0 0 1 .895.12l2.6 2.6Z',
      fill: '#fff',
    }),
  );
});
clerkSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var clerk = {
  category: 'brand',
  colorable: false,
  name: 'clerk',
  svg: clerkSvg,
};
